import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
export default class ConsultWidget extends React.Component {
    constructor(props) {
        super(props);
        //console.warn("TODO: update ConsultWidget isValidUser state");
        //window.s_user_group="Physician";
        //window.s_user_origin="us";
        this.state = {
            isValidUser: (props.user.isLoggedIn && props.user.professionId==10)
            //isValidUser: true
        };
    }
    componentDidMount() {
        this.loadScript();
    }
    componentDidUpdate(prevProps, prevState){
        this.loadScript();
    }
    componentWillUnmount(){
    }
    componentWillMount(){
        this.loadCss();
    }
    componentWillUpdate(nextProps, nextState){
        this.loadCss();
    }
    loadCss(){
        if(!this.state.isValidUser){
            return;
        }
        if($('#share-widget-styles').length==0){
            const cssUrl = `${window.medscape.config.staticServer.host}/medscape-core/consult/css/widget/consult-widget.css`;
            $('head').append( $('<link id="share-widget-styles" rel="stylesheet" type="text/css" />').attr('href',cssUrl) );
        }
    }
    loadScript() {
      if(!this.state.isValidUser) {
        return;
      }
      const scriptUrl = `${window.medscape.config.staticServer.host}/medscape-core/consult/js/widget/consult-widget.js`;
      $.getScript( scriptUrl, function( data, textStatus, jqxhr ) {});
    }
    render() {
        if(!this.state.isValidUser){
            return false;
        }
        const JoinDiscussionLink = {
            href: "",
            target: "_blank",
            onClick: (e)=>{
                try{
                    window.wmdTrack('ct-wdgt_btn');
                }catch(e){}
            },
            dangerouslySetInnerHTML: Utils.getDangerousHtml(this.props.copy.footer)
        }

        const widgetProps = {
            "className": "cslt-widg-inst" ,
            "type": "hidden",
            "data-tag": this.props.tag,
            "data-size": this.props.size,
            "data-link-target": "blank"
        }

        return(
            <div className="consult-widget">
                <div className="consult-bucket">
                    <input {...widgetProps } />

                    <div className="consult-bucket-header" dangerouslySetInnerHTML={Utils.getDangerousHtml(this.props.copy.header)}></div>
                        <div className="consult-bucket-content">
                            <ul>

                            </ul>
                        </div>
                    <div className="consult-bucket-footer"><a {...JoinDiscussionLink}></a></div>
                </div>
            </div>
        )
    }
}
ConsultWidget.propTypes={
    tag: React.PropTypes.string.isRequired,
    size: React.PropTypes.number,
    user: React.PropTypes.object
}
ConsultWidget.defaultProps={
    size: 3,
    user: {
        isLoggedIn: false,
        professionId: -1
    }
}



// WEBPACK FOOTER //
// ./medscape_modules/consult-widget/app.jsx